import { ContentRecommendation } from '@/components/content/ContentRecommendation';

const EMS_NAME = 'DPSV2_GlobalStyles';

const NullElement = () => null;

export const GlobalStylesContentRecommendation = () => (
	<ContentRecommendation
		id={EMS_NAME}
		withoutFrame
		properties={{
			emsName: EMS_NAME,
		}}
		loadingElement={<NullElement />}
	/>
);
